import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import React from "react";
import { AuditToggleButtonContainer, TOGGLE_BUTTON_LEFT, TOGGLE_BUTTON_RIGHT } from "../../Feeds.style";
import { Box } from "@material-ui/core";
import { Theme } from "@orijinworks/frontend-commons";

export const AuditToggleButton = ({ selectedType, onTypeChange }) => {
    return (
        <Theme>
            <AuditToggleButtonContainer>
                <ToggleButtonGroup
                    value={selectedType}
                    color="primary"
                    exclusive
                    aria-label="Audit type filter"
                    onChange={onTypeChange}
                    role="radiogroup"
                >
                    <ToggleButton
                        className="toggle-button-left"
                        value={"Conversations"}
                        role="radio"
                        aria-checked={selectedType === 'Conversations'}
                        aria-label="Show my conversations audit"
                    >
                        Conversations
                    </ToggleButton>
                    <ToggleButton
                        className="toggle-button-right"
                        value={"Announcements"}
                        role="radio"
                        aria-checked={selectedType === 'Announcements'}
                        aria-label="Show all announcements audit"
                    >
                        Announcements
                    </ToggleButton>
                </ToggleButtonGroup>
            </AuditToggleButtonContainer>
        </Theme>
    );
};